import React from 'react';
import { observer } from 'mobx-react-lite';
import { Div } from '@icecreamsocial/components';
import {
	QuerySearchBar,
	Pagename,
} from '../../../../../../../../presentational';
import { ConversionFiltersProvider } from './components/FilterProvider';
import { Table } from './components/Table';
import FilterForm from './components/FilterForm';
import { ExportButton } from './components/ExportButton';

const Conversions = () => {
	return (
		<ConversionFiltersProvider>
			<Div display='flex'>
				<Div elWidth='75%'>
					<Div
						display='flex'
						alignItems='center'
						justifyContent='space-between'
					>
						<Pagename>Conversions</Pagename>
						<ExportButton />
					</Div>
					<Div>
						<QuerySearchBar
							id='conversionsSearch'
							name='search'
							placeholder='Find Conversions'
						/>
						<Table />
					</Div>
				</Div>
				<Div as='aside' elWidth='25%' marginLeft='lg' marginBottom='lg'>
					<Div position='sticky' positionTop='0'>
						<FilterForm />
					</Div>
				</Div>
			</Div>
		</ConversionFiltersProvider>
	);
};

Conversions.displayName = 'Campaigns.Campaign.Reports.Conversions';
export default observer(Conversions);
